module.exports = __webpack_public_path__ + "media/bgm.885b18e5.mp3";